import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=cbb5c5a4&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=cbb5c5a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb5c5a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbb5c5a4')) {
      api.createRecord('cbb5c5a4', component.options)
    } else {
      api.reload('cbb5c5a4', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=cbb5c5a4&scoped=true&", function () {
      api.rerender('cbb5c5a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2X6nim3Rxa1gq/JS/comp/SearchFilterTokens.vue"
export default component.exports